import { WifiOff, RefreshCw } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNetwork } from '../../hooks/useNetwork';

export function OfflineFeedback() {
    const isOnline = useNetwork();

    return (
        <AnimatePresence>
            {!isOnline && (
                <motion.div
                    initial={{ y: 50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 50, opacity: 0 }}
                    className="fixed bottom-24 left-1/2 -translate-x-1/2 z-[100] w-11/12 max-w-md"
                >
                    <div className="bg-red-500/95 dark:bg-red-900/95 backdrop-blur-md text-white p-4 rounded-2xl shadow-2xl flex items-center justify-between gap-4 border border-white/20">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-white/10 rounded-xl">
                                <WifiOff size={20} className="animate-pulse" />
                            </div>
                            <div className="flex flex-col">
                                <span className="font-bold text-sm">Você está offline</span>
                                <span className="text-[10px] text-white/70">As informações podem estar desatualizadas.</span>
                            </div>
                        </div>
                        <button
                            onClick={() => window.location.reload()}
                            className="p-2 bg-white/10 hover:bg-white/20 transition-colors rounded-xl border-none cursor-pointer"
                            aria-label="Tentar novamente"
                        >
                            <RefreshCw size={18} />
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
